import styled from 'styled-components';

export const SimulationContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-right: 0.25rem;
`;
